var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { isValidObject, Typography } from '@airtel/air-design-system';
export var TypographyWidgetComponent = props => {
  var onUserAction = props.onUserAction,
    hyperLinkPressMetaData = props.hyperLinkPressMetaData,
    id = props.id,
    multiText = props.multiText,
    onPress = props.onPress,
    onPressIn = props.onPressIn,
    onPressOut = props.onPressOut,
    onLongPress = props.onLongPress,
    restProps = __rest(props, ["onUserAction", "hyperLinkPressMetaData", "id", "multiText", "onPress", "onPressIn", "onPressOut", "onLongPress"]);
  var _multiText = multiText === null || multiText === void 0 ? void 0 : multiText.map(singleText => Object.assign(Object.assign({}, singleText), {
    onPress: isValidObject(singleText === null || singleText === void 0 ? void 0 : singleText.hyperLinkPressMetaData) && (() => onUserAction(singleText === null || singleText === void 0 ? void 0 : singleText.hyperLinkPressMetaData, singleText))
  }));
  var pressHandlers = {
    onPress: (isValidObject(hyperLinkPressMetaData) || isValidObject(onPress)) && (() => {
      var action = hyperLinkPressMetaData || onPress;
      return onUserAction(Object.assign({
        id
      }, action), props);
    }),
    onPressIn: isValidObject(onPressIn) && (() => onUserAction(onPressIn, props)),
    onPressOut: isValidObject(onPressOut) && (() => onUserAction(onPressOut, props)),
    onLongPress: isValidObject(onLongPress) && (() => onUserAction(onLongPress, props))
  };
  return _jsx(Typography, Object.assign({}, restProps, pressHandlers, {
    multiText: _multiText
  }));
};
TypographyWidgetComponent.genericRendererKey = 'AirTypographyWidget';